module.exports = __webpack_public_path__ + "media/contact/contact_banner-b4f48011.jpg";